(function () {
  "use strict";
  if (window.__fragrance_js_loaded) return;
  window.__fragrance_js_loaded = true;

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function isMobileSwipeDevice() {
    return (
      (window.matchMedia &&
        window.matchMedia("(hover: none) and (pointer: coarse)").matches) ||
      (navigator.maxTouchPoints || 0) > 0 ||
      "ontouchstart" in window
    );
  }

  function attachMobileSwipe(container, onDirection) {
    if (!container || !isMobileSwipeDevice()) return;

    var swipeStartX = null;
    var swipeStartY = null;
    var swipeStartTime = null;
    var swipeThreshold = 40;
    var swipeRestraint = 100;
    var swipeAllowedTime = 500;

    var onSwipeStart = function (x, y) {
      swipeStartX = x;
      swipeStartY = y;
      swipeStartTime = Date.now();
    };

    var onSwipeEnd = function (x, y) {
      if (swipeStartX === null || swipeStartTime === null) return;
      var distX = x - swipeStartX;
      var distY = y - swipeStartY;
      var elapsed = Date.now() - swipeStartTime;
      swipeStartX = null;
      swipeStartY = null;
      swipeStartTime = null;

      if (
        elapsed <= swipeAllowedTime &&
        Math.abs(distX) >= swipeThreshold &&
        Math.abs(distY) <= swipeRestraint
      ) {
        if (distX < 0) onDirection("left");
        else if (distX > 0) onDirection("right");
      }
    };

    var supportsPointer = typeof window.PointerEvent !== "undefined";

    if (supportsPointer) {
      container.addEventListener(
        "pointerdown",
        function (e) {
          if (e.pointerType === "mouse" && e.button !== 0) return;
          onSwipeStart(e.clientX, e.clientY);
          if (container.setPointerCapture) {
            container.setPointerCapture(e.pointerId);
          }
        },
        { passive: true },
      );

      container.addEventListener(
        "pointerup",
        function (e) {
          onSwipeEnd(e.clientX, e.clientY);
          if (container.releasePointerCapture) {
            container.releasePointerCapture(e.pointerId);
          }
        },
        { passive: true },
      );

      container.addEventListener("pointercancel", function () {
        swipeStartX = null;
        swipeStartY = null;
        swipeStartTime = null;
      });
    } else {
      container.addEventListener(
        "touchstart",
        function (e) {
          if (e.touches.length !== 1) return;
          onSwipeStart(e.touches[0].clientX, e.touches[0].clientY);
        },
        { passive: true },
      );

      container.addEventListener(
        "touchend",
        function (e) {
          if (e.changedTouches.length !== 1) return;
          onSwipeEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        },
        { passive: true },
      );
    }
  }

  function initHero(root) {
    if (!root || root.dataset.frgHeroInit === "true") return;
    root.dataset.frgHeroInit = "true";

    var ratingLink = root.querySelector("[data-frg-scroll]");
    if (ratingLink) {
      ratingLink.addEventListener("click", function (e) {
        var target = document.getElementById(
          ratingLink.getAttribute("data-frg-scroll"),
        );
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({
          top: y,
          behavior: prefersReducedMotion() ? "auto" : "smooth",
        });
      });
    }

    var caseScopes = root.querySelectorAll("[data-case-scope]");
    caseScopes.forEach(function (scope) {
      var caseInput = scope.querySelector("[data-case-color-input]");
      var dropdown = scope.querySelector("[data-frg-case]");
      if (!caseInput || !dropdown) return;

      var trigger = dropdown.querySelector("[data-frg-case-trigger]");
      var menu = dropdown.querySelector("[data-frg-case-menu]");
      var display = dropdown.querySelector("[data-frg-case-display]");
      var errorEl = dropdown.querySelector("[data-frg-case-error]");
      var preview = scope.querySelector("[data-frg-case-preview]");
      var options = Array.prototype.slice.call(
        dropdown.querySelectorAll("[data-frg-case-option]"),
      );

      var bundleType = scope.getAttribute("data-frg-bundle");
      var productTitle = scope.getAttribute("data-frg-product-title") || "";

      // Optional add-on (10ml one-time card): the case is only added, and a
      // color only required, while the add-on checkbox is ticked.
      var addonToggle = scope.hasAttribute("data-frg-case-optional")
        ? scope.querySelector("[data-frg-case-toggle]")
        : null;
      var addonPanel = scope.querySelector("[data-frg-case-panel]");

      if (preview && !preview.getAttribute("data-frg-default-src")) {
        preview.setAttribute(
          "data-frg-default-src",
          preview.getAttribute("src") || "",
        );
      }

      function openMenu() {
        if (menu) menu.hidden = false;
        dropdown.classList.add("is-open");
        if (trigger) trigger.setAttribute("aria-expanded", "true");
      }
      function closeMenu() {
        if (menu) menu.hidden = true;
        dropdown.classList.remove("is-open");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }
      function clearError() {
        dropdown.classList.remove("has-error");
        if (errorEl) errorEl.hidden = true;
      }
      function focusOption(i) {
        if (!options.length) return;
        if (i < 0) i = options.length - 1;
        if (i >= options.length) i = 0;
        options[i].focus();
      }
      function updatePreview(opt) {
        if (!preview) return;
        var img = opt.getAttribute("data-case-image");
        preview.src = img || preview.getAttribute("data-frg-default-src") || "";
      }
      function wantsCase() {
        return !addonToggle || addonToggle.checked;
      }
      function setAddon(on) {
        if (addonPanel) addonPanel.hidden = !on;
        scope.classList.toggle("has-case-addon", on);
        scope.querySelectorAll("[data-frg-price-bottle]").forEach(function (el) {
          el.hidden = on;
        });
        scope.querySelectorAll("[data-frg-price-bundle]").forEach(function (el) {
          el.hidden = !on;
        });
        if (!on) {
          clearError();
          closeMenu();
        }
      }
      function selectOption(opt) {
        if (opt.getAttribute("data-case-unavailable")) return;

        caseInput.value = opt.getAttribute("data-case-color") || "";
        if (display) display.innerHTML = opt.innerHTML;
        options.forEach(function (o) {
          o.classList.remove("is-selected");
          o.setAttribute("aria-selected", "false");
        });
        opt.classList.add("is-selected");
        opt.setAttribute("aria-selected", "true");
        dropdown.classList.add("has-value");
        updatePreview(opt);
        clearError();
        closeMenu();
        if (trigger) trigger.focus();
      }

      if (trigger) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          if (menu && menu.hidden) openMenu();
          else closeMenu();
        });

        trigger.addEventListener("keydown", function (e) {
          var isOpenKey =
            e.key === "ArrowDown" ||
            e.key === "Down" ||
            e.key === "Enter" ||
            e.key === " " ||
            e.key === "Spacebar";
          if (isOpenKey && menu && menu.hidden) {
            e.preventDefault();
            openMenu();
            var sel = options.indexOf(
              dropdown.querySelector(".frg-case__option.is-selected"),
            );
            focusOption(sel >= 0 ? sel : 0);
          }
        });
      }

      options.forEach(function (opt, i) {
        opt.addEventListener("click", function () {
          selectOption(opt);
        });
        opt.addEventListener("keydown", function (e) {
          switch (e.key) {
            case "ArrowDown":
            case "Down":
              e.preventDefault();
              focusOption(i + 1);
              break;
            case "ArrowUp":
            case "Up":
              e.preventDefault();
              focusOption(i - 1);
              break;
            case "Home":
              e.preventDefault();
              focusOption(0);
              break;
            case "End":
              e.preventDefault();
              focusOption(options.length - 1);
              break;
            case "Enter":
            case " ":
            case "Spacebar":
              e.preventDefault();
              selectOption(opt);
              break;
            case "Escape":
            case "Esc":
              e.preventDefault();
              closeMenu();
              if (trigger) trigger.focus();
              break;
            case "Tab":
              closeMenu();
              break;
          }
        });
      });

      document.addEventListener("click", function (e) {
        if (!dropdown.contains(e.target)) closeMenu();
      });
      dropdown.addEventListener("keydown", function (e) {
        if ((e.key === "Escape" || e.key === "Esc") && menu && !menu.hidden) {
          closeMenu();
          if (trigger) trigger.focus();
        }
      });

      dropdown.addEventListener("animationend", function (e) {
        if (e.animationName === "frgCaseShake") {
          dropdown.classList.remove("frg-case--shake");
        }
      });

      function flagInvalid(submitter) {
        dropdown.classList.add("has-error");
        if (errorEl) errorEl.hidden = false;

        if (submitter) {
          submitter.classList.add("frg-cta-pressed");
          window.setTimeout(function () {
            submitter.classList.remove("frg-cta-pressed");
          }, 180);
        }

        if (!prefersReducedMotion()) {
          dropdown.classList.remove("frg-case--shake");
          void dropdown.offsetWidth;
          dropdown.classList.add("frg-case--shake");
        }

        try {
          dropdown.scrollIntoView({
            block: "center",
            behavior: prefersReducedMotion() ? "auto" : "smooth",
          });
        } catch (err) {}

        window.setTimeout(function () {
          openMenu();
          if (trigger) trigger.focus();
        }, 0);
      }

      function shopRoot() {
        return window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root
          : "/";
      }

      function submitBundle(submitter) {
        var form = scope.querySelector('form[action*="/cart/add"]');
        var selected = dropdown.querySelector(".frg-case__option.is-selected");
        if (!form || !selected) {
          flagInvalid(submitter);
          return;
        }

        var caseVariantId = selected.getAttribute("data-case-variant-id");
        if (!caseVariantId) return;

        var idInput = form.querySelector('[name="id"]');
        var planInput = form.querySelector('[name="selling_plan"]');
        var successInput = form.querySelector('[name="on_success"]');
        var onSuccess = successInput ? successInput.value : "force_open_drawer";
        var fragranceVariantId = idInput.value;

        var fragranceItem = { id: Number(fragranceVariantId), quantity: 1 };
        if (bundleType === "subscription" && planInput && planInput.value) {
          fragranceItem.selling_plan = Number(planInput.value);
        }

        var caseProps;
        if (bundleType === "subscription") {
          caseProps = {
            _linked_to: productTitle,
            _parent_id: String(fragranceVariantId),
            _case_for: "10ml subscription",
            _free_with_subscription: "true",
            _parent_fragrance_product: productTitle,
          };
        } else {
          caseProps = {
            _linked_to: productTitle,
            _parent_id: String(fragranceVariantId),
            _case_for: "10ml travel spray",
          };
        }
        var caseItem = {
          id: Number(caseVariantId),
          quantity: 1,
          properties: caseProps,
        };

        var sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: sections },
          }),
        );

        if (submitter) submitter.setAttribute("aria-busy", "true");
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:start", { bubbles: true }),
        );

        fetch(shopRoot() + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: [fragranceItem, caseItem],
            sections: sections.join(","),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (res) {
            return res.json().then(function (json) {
              return { ok: res.ok, json: json };
            });
          })
          .then(function (r) {
            if (submitter) submitter.removeAttribute("aria-busy");
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:loading:end", { bubbles: true }),
            );
            if (!r.ok) {
              form.dispatchEvent(
                new CustomEvent("cart:error", {
                  bubbles: true,
                  detail: {
                    error:
                      (r.json && r.json.description) ||
                      "Could not add to cart.",
                  },
                }),
              );
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              return;
            }
            var settings =
              (window.themeVariables && window.themeVariables.settings) || {};
            if (settings.cartType === "page" || settings.pageType === "cart") {
              window.location.href = shopRoot() + "cart";
              return;
            }
            fetch(shopRoot() + "cart.js")
              .then(function (c) {
                return c.json();
              })
              .then(function (cart) {
                cart.sections = r.json.sections;
                form.dispatchEvent(
                  new CustomEvent("variant:add", {
                    bubbles: true,
                    detail: {
                      items: r.json.items || [r.json],
                      cart: cart,
                      onSuccessDo: onSuccess,
                    },
                  }),
                );
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      baseEvent: "variant:add",
                      onSuccessDo: onSuccess,
                      cart: cart,
                    },
                  }),
                );
              });
          })
          .catch(function () {
            if (submitter) submitter.removeAttribute("aria-busy");
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:loading:end", { bubbles: true }),
            );
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          });
      }

      if (addonToggle) {
        addonToggle.addEventListener("change", function () {
          setAddon(addonToggle.checked);
          // Ticking the add-on goes straight to the color choice.
          if (addonToggle.checked && !caseInput.value) openMenu();
        });
        // Sync with a checkbox state the browser restored (back/forward nav).
        setAddon(addonToggle.checked);
      }

      scope.addEventListener(
        "submit",
        function (e) {
          // Add-on unticked: let the theme's product-form add the bottle alone.
          if (!wantsCase()) return;
          if (!caseInput.value) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }
            flagInvalid(e.submitter);
            return;
          }
          if (bundleType) {
            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === "function") {
              e.stopImmediatePropagation();
            }
            submitBundle(e.submitter);
          }
        },
        true,
      );
    });

    var timer = root.querySelector("[data-frg-timer]");
    if (timer) {
      var minutes = parseInt(timer.getAttribute("data-minutes"), 10) || 20;
      var storeKey = timer.getAttribute("data-storage-key") || "frg-sub-timer";
      var minEl = timer.querySelector("[data-timer-min]");
      var secEl = timer.querySelector("[data-timer-sec]");
      var pad = function (n) {
        return (n < 10 ? "0" : "") + n;
      };

      var endAt = null;
      try {
        var stored = sessionStorage.getItem(storeKey);
        if (stored) endAt = parseInt(stored, 10);
      } catch (e) {}

      if (!endAt || isNaN(endAt)) {
        endAt = Date.now() + minutes * 60 * 1000;
        try {
          sessionStorage.setItem(storeKey, String(endAt));
        } catch (e) {}
      }

      var renderTimer = function () {
        var remaining = Math.round((endAt - Date.now()) / 1000);
        if (remaining < 0) {
          timer.style.display = "none";
          clearInterval(timerIv);
          return;
        }
        if (minEl) minEl.textContent = pad(Math.floor(remaining / 60));
        if (secEl) secEl.textContent = pad(remaining % 60);
      };
      renderTimer();
      var timerIv = setInterval(renderTimer, 1000);
    }

    var track = root.querySelector(".frg-gallery__track");
    var badges = root.querySelector(".frg-gallery__badges");
    var dotsWrap = root.querySelector(".frg-gallery__dots");
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll(".frg-gallery__thumb"),
    );
    var dots = dotsWrap
      ? Array.prototype.slice.call(
          dotsWrap.querySelectorAll(".frg-gallery__dot"),
        )
      : [];
    var slides = track
      ? Array.prototype.slice.call(
          track.querySelectorAll(".frg-gallery__slide"),
        )
      : [];
    var prevBtn = root.querySelector(".frg-gallery__nav--prev");
    var nextBtn = root.querySelector(".frg-gallery__nav--next");
    if (!slides.length) return;

    var lastIndex = slides.length - 1;
    var startIndex = track
      ? parseInt(track.getAttribute("data-start-index"), 10) || 0
      : 0;
    var currentIndex = startIndex;

    function loadSlide(index) {
      var slide = slides[index];
      if (!slide) return;
      var img = slide.querySelector("img");
      if (!img) {
        slide.classList.add("is-loaded");
        return;
      }

      if (!img.getAttribute("src") && img.dataset.src) {
        img.src = img.dataset.src;
      }
      if (img.complete && img.naturalWidth > 0) {
        slide.classList.add("is-loaded");
      } else {
        img.addEventListener(
          "load",
          function () {
            slide.classList.add("is-loaded");
          },
          { once: true },
        );
        img.addEventListener(
          "error",
          function () {
            slide.classList.add("is-loaded");
          },
          { once: true },
        );
      }
    }

    function setActive(list, index) {
      list.forEach(function (el, i) {
        el.classList.toggle("is-active", i === index);
      });
    }

    function go(index) {
      if (index < 0) index = 0;
      if (index > lastIndex) index = lastIndex;
      currentIndex = index;

      if (track) track.style.transform = "translateX(-" + index * 100 + "%)";
      setActive(thumbs, index);
      setActive(dots, index);
      if (prevBtn) prevBtn.hidden = index === 0;
      if (nextBtn) nextBtn.hidden = index === lastIndex;
      if (badges) badges.style.display = index === 0 ? "" : "none";
      loadSlide(index);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        go(i);
      });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        go(i);
      });
    });
    if (prevBtn)
      prevBtn.addEventListener("click", function () {
        go(currentIndex - 1);
      });
    if (nextBtn)
      nextBtn.addEventListener("click", function () {
        go(currentIndex + 1);
      });

    var viewport = root.querySelector(".frg-gallery__viewport");
    if (viewport) {
      attachMobileSwipe(viewport, function (direction) {
        if (direction === "left") go(currentIndex + 1);
        else if (direction === "right") go(currentIndex - 1);
      });
    }

    if (track) {
      track.style.transition = "none";
      track.style.transform = "translateX(-" + startIndex * 100 + "%)";
      void track.offsetWidth;
      track.style.transition = "";
    }
    setActive(thumbs, startIndex);
    setActive(dots, startIndex);
    if (prevBtn) prevBtn.hidden = startIndex === 0;
    if (nextBtn) nextBtn.hidden = startIndex === lastIndex;
    if (badges) badges.style.display = startIndex === 0 ? "" : "none";
    loadSlide(startIndex);
  }

  function initFeaturedNotes(root) {
    if (!root || root.dataset.ffnInit === "true") return;
    root.dataset.ffnInit = "true";

    var notes = Array.prototype.slice.call(root.querySelectorAll(".ffn__note"));
    var panels = Array.prototype.slice.call(
      root.querySelectorAll(".ffn__panel"),
    );
    var media = Array.prototype.slice.call(
      root.querySelectorAll(".ffn__media-item"),
    );
    var prevBtn = root.querySelector(".ffn__media-nav--prev");
    var nextBtn = root.querySelector(".ffn__media-nav--next");
    var mediaStage = root.querySelector(".ffn__media-stage");
    var currentIndex = 0;
    if (!notes.length) return;

    function updateNavButtons() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === notes.length - 1;
    }

    function activate(index) {
      notes.forEach(function (note, i) {
        var on = i === index;
        note.classList.toggle("is-active", on);
        note.setAttribute("aria-selected", on ? "true" : "false");
        note.setAttribute("tabindex", on ? "0" : "-1");
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle("is-active", on);
        if (on) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      });
      media.forEach(function (item, i) {
        var on = i === index;
        item.classList.toggle("is-active", on);
        if (on) item.removeAttribute("aria-hidden");
        else item.setAttribute("aria-hidden", "true");
      });
      updateNavButtons();
    }

    function setCurrent(index) {
      if (index < 0) index = 0;
      if (index > notes.length - 1) index = notes.length - 1;
      currentIndex = index;
      activate(index);
    }

    notes.forEach(function (note, i) {
      note.addEventListener("click", function () {
        setCurrent(i);
      });
      note.addEventListener("keydown", function (e) {
        var next = null;
        if (e.key === "ArrowRight") next = (i + 1) % notes.length;
        else if (e.key === "ArrowLeft")
          next = (i - 1 + notes.length) % notes.length;
        else if (e.key === "Home") next = 0;
        else if (e.key === "End") next = notes.length - 1;
        if (next === null) return;
        e.preventDefault();
        setCurrent(next);
        notes[next].focus();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        setCurrent(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        setCurrent(currentIndex + 1);
      });
    }

    if (mediaStage) {
      attachMobileSwipe(mediaStage, function (direction) {
        if (direction === "left") setCurrent(currentIndex + 1);
        else if (direction === "right") setCurrent(currentIndex - 1);
      });
    }

    setCurrent(currentIndex);
  }

  function stepFor(track) {
    var item = track.firstElementChild;
    var gap = parseInt(track.getAttribute("data-gap"), 10) || 0;
    var advance = parseInt(track.getAttribute("data-advance"), 10) || 1;
    var width = item ? item.offsetWidth + gap : track.clientWidth;
    return width * advance;
  }

  function initSlider(wrap) {
    if (!wrap || wrap.dataset.frgSliderInit === "true") return;
    wrap.dataset.frgSliderInit = "true";

    var track = wrap.querySelector("[data-frg-slider-track]");
    if (!track) return;

    var prev = wrap.querySelector("[data-frg-slider-prev]");
    var next = wrap.querySelector("[data-frg-slider-next]");

    if (prev) {
      prev.addEventListener("click", function () {
        track.scrollLeft -= stepFor(track);
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        track.scrollLeft += stepFor(track);
      });
    }
  }

  function initStickyBanner(banner) {
    if (!banner || banner.dataset.frsbInit === "true") return;
    banner.dataset.frsbInit = "true";

    var minutesEl = banner.querySelector("[data-frsb-min]");
    var secondsEl = banner.querySelector("[data-frsb-sec]");
    if (minutesEl && secondsEl) {
      var minutes =
        parseInt(banner.getAttribute("data-timer-minutes"), 10) || 20;
      var now = Date.now();
      var key =
        banner.getAttribute("data-storage-key") || "fragranceBannerStart";
      var endAt = null;
      try {
        var stored = sessionStorage.getItem(key);
        if (stored) endAt = parseInt(stored, 10);
      } catch (e) {}
      if (!endAt || isNaN(endAt)) {
        endAt = now + minutes * 60 * 1000;
        try {
          sessionStorage.setItem(key, String(endAt));
        } catch (e) {}
      }

      var format = function (value) {
        return (value < 10 ? "0" : "") + value;
      };
      var render = function () {
        var remaining = Math.round((endAt - Date.now()) / 1000);
        if (remaining < 0) {
          banner.style.display = "none";
          clearInterval(iv);
          return;
        }
        minutesEl.textContent = format(Math.floor(remaining / 60));
        secondsEl.textContent = format(remaining % 60);
      };
      render();
      var iv = setInterval(render, 1000);
    }

    var hero =
      document.querySelector(".frg-hero") ||
      document.querySelector(".fragrance-product-hero-section");
    var isVisible = false;

    var setVisible = function (show) {
      if (show === isVisible) return;
      isVisible = show;
      banner.classList.toggle("is-visible", isVisible);
    };

    var shouldShow = function () {
      if (!hero) return true;
      var rect = hero.getBoundingClientRect();
      return rect.bottom <= 0;
    };

    var checkScroll = function () {
      setVisible(shouldShow());
    };

    if (hero && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          setVisible(
            !entry.isIntersecting && entry.boundingClientRect.bottom <= 0,
          );
        },
        { threshold: 0 },
      );
      observer.observe(hero);
      checkScroll();
      return;
    }

    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            checkScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true },
    );

    window.addEventListener("resize", checkScroll, { passive: true });
    checkScroll();
  }

  function setupCollectionPersonalize() {
    if (window.__frgPersonalizeBound) return;
    window.__frgPersonalizeBound = true;

    function openDrawer(drawer, groupType) {
      if (!drawer) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("frg-personalize-lock");
      var form = drawer.querySelector(".frg-personalize__form");
      if (!form) return;

      form.scrollTop = 0;
      if (!groupType) return;

      var grp = drawer.querySelector('[data-frg-group="' + groupType + '"]');
      if (!grp) return;

      var reduced = prefersReducedMotion();
      window.setTimeout(
        function () {
          var top = Math.max(0, grp.offsetTop - 12);
          if (reduced || !form.scrollTo) {
            form.scrollTop = top;
          } else {
            form.scrollTo({ top: top, behavior: "smooth" });
          }
        },
        reduced ? 0 : 280,
      );
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("frg-personalize-lock");
    }

    function buildParams(drawer) {
      var form = drawer.querySelector("[data-frg-personalize-form]");
      var params = new URLSearchParams();
      if (!form) return params;
      Array.prototype.forEach.call(
        form.querySelectorAll("input[type=radio]:checked"),
        function (inp) {
          params.append(inp.name, inp.value);
        },
      );
      return params;
    }

    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-frg-personalize-open]");
      if (openBtn) {
        var section = openBtn.closest(".shopify-section") || document;
        openDrawer(
          section.querySelector(".frg-personalize"),
          openBtn.getAttribute("data-frg-personalize-open"),
        );
        return;
      }

      var closeBtn = e.target.closest("[data-frg-personalize-close]");
      if (closeBtn) {
        closeDrawer(closeBtn.closest(".frg-personalize"));
        return;
      }

      var applyBtn = e.target.closest("[data-frg-apply]");
      if (applyBtn) {
        var drawer = applyBtn.closest(".frg-personalize");
        var url = (drawer && drawer.__applyUrl) || buildApplyFallback(drawer);
        if (url) frgNavigate(url);
        return;
      }

      var tile = e.target.closest(".frg-personalize__tile");
      if (tile && tile.__wasChecked) {
        e.preventDefault();
        var input = tile.querySelector("input[type=radio]");
        if (input) input.checked = false;
        tile.__wasChecked = false;
        (input || tile).dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    function buildApplyFallback(drawer) {
      if (!drawer) return null;
      var query = buildParams(drawer).toString();
      return window.location.pathname + (query ? "?" + query : "");
    }

    document.addEventListener("mousedown", function (e) {
      var tile = e.target.closest(".frg-personalize__tile");
      if (!tile) return;
      var input = tile.querySelector("input[type=radio]");
      tile.__wasChecked = !!(input && input.checked);
    });

    document.addEventListener("change", function (e) {
      if (!e.target.closest || !e.target.closest(".frg-personalize")) return;
      if (e.target.type !== "radio") return;
      var group = e.target.closest("[data-frg-group]");
      if (group) {
        Array.prototype.forEach.call(
          group.querySelectorAll(".frg-personalize__tile"),
          function (t) {
            var i = t.querySelector("input[type=radio]");
            t.classList.toggle("is-selected", !!(i && i.checked));
          },
        );
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" && e.key !== "Esc") return;
      var open = document.querySelector(".frg-personalize.is-open");
      if (open) closeDrawer(open);
    });
  }

  function setupCollectionExplore() {
    if (window.__frgExploreBound) return;
    window.__frgExploreBound = true;

    function setView(drawer, view) {
      var views = drawer.querySelectorAll(".frg-explore__view");
      Array.prototype.forEach.call(views, function (v) {
        v.classList.toggle(
          "is-active",
          v.getAttribute("data-frg-view") === view,
        );
      });
      drawer.setAttribute("data-active-view", view);

      var active = drawer.querySelector(
        '.frg-explore__view[data-frg-view="' + view + '"]',
      );
      if (active) {
        var body = active.querySelector(".frg-explore__body");
        if (body) body.scrollTop = 0;
      }
    }

    function applyAlphaFilter(drawer) {
      if (!drawer) return;
      var notesView = drawer.querySelector(
        '.frg-explore__view[data-frg-view="notes"]',
      );
      if (!notesView) return;
      var active = Array.prototype.map.call(
        notesView.querySelectorAll(".frg-explore__alpha-btn.is-active"),
        function (b) {
          return b.getAttribute("data-frg-alpha");
        },
      );
      Array.prototype.forEach.call(
        notesView.querySelectorAll(".frg-explore__tile"),
        function (t) {
          var show =
            active.length === 0 ||
            active.indexOf(t.getAttribute("data-letter")) !== -1;
          t.classList.toggle("is-hidden", !show);
        },
      );
    }

    function openDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("frg-explore-lock");
      setView(drawer, "main");
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("frg-explore-lock");
    }

    function buildParams(drawer) {
      var form = drawer.querySelector("[data-frg-explore-form]");
      var params = new URLSearchParams();
      if (!form) return params;
      Array.prototype.forEach.call(
        form.querySelectorAll("input[type=checkbox]:checked"),
        function (inp) {
          params.append(inp.name, inp.value);
        },
      );
      return params;
    }

    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-frg-explore-open]");
      if (openBtn) {
        var section = openBtn.closest(".shopify-section") || document;
        openDrawer(section.querySelector(".frg-explore"));
        return;
      }

      var closeBtn = e.target.closest("[data-frg-explore-close]");
      if (closeBtn) {
        closeDrawer(closeBtn.closest(".frg-explore"));
        return;
      }

      var gotoBtn = e.target.closest("[data-frg-explore-goto]");
      if (gotoBtn) {
        setView(
          gotoBtn.closest(".frg-explore"),
          gotoBtn.getAttribute("data-frg-explore-goto"),
        );
        return;
      }

      var backBtn = e.target.closest("[data-frg-explore-back]");
      if (backBtn) {
        setView(backBtn.closest(".frg-explore"), "main");
        return;
      }

      var alphaBtn = e.target.closest("[data-frg-alpha]");
      if (alphaBtn) {
        var on = alphaBtn.classList.toggle("is-active");
        alphaBtn.setAttribute("aria-pressed", on ? "true" : "false");
        applyAlphaFilter(alphaBtn.closest(".frg-explore"));
        return;
      }

      var applyBtn = e.target.closest("[data-frg-explore-apply]");
      if (applyBtn) {
        var drawer = applyBtn.closest(".frg-explore");
        var url =
          (drawer && drawer.__applyUrl) ||
          window.location.pathname +
            (buildParams(drawer).toString()
              ? "?" + buildParams(drawer).toString()
              : "");
        if (url) frgNavigate(url);
        return;
      }

      var clearBtn = e.target.closest("[data-frg-explore-clear]");
      if (clearBtn) {
        var d = clearBtn.closest(".frg-explore");
        var form = d.querySelector("[data-frg-explore-form]");
        if (form) {
          Array.prototype.forEach.call(
            form.querySelectorAll("input[type=checkbox]:checked"),
            function (inp) {
              inp.checked = false;
            },
          );
          Array.prototype.forEach.call(
            form.querySelectorAll(".frg-explore__tile.is-selected"),
            function (t) {
              t.classList.remove("is-selected");
            },
          );
        }

        frgScheduleRecompute(d.closest(".shopify-section") || document);
        return;
      }
    });

    document.addEventListener("change", function (e) {
      if (!e.target.closest || !e.target.closest(".frg-explore")) return;
      if (e.target.type !== "checkbox") return;
      var tile = e.target.closest(".frg-explore__tile");
      if (tile) tile.classList.toggle("is-selected", e.target.checked);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" && e.key !== "Esc") return;
      var open = document.querySelector(".frg-explore.is-open");
      if (!open) return;

      if (open.getAttribute("data-active-view") !== "main")
        setView(open, "main");
      else closeDrawer(open);
    });
  }

  var frgCascadeTimers = new WeakMap();
  var frgCascadeCtrls = new WeakMap();

  function frgCascadeSectionId(section) {
    var d = section.querySelector(".frg-personalize, .frg-explore");
    return d ? d.getAttribute("data-section-id") : null;
  }

  function frgCollectParams(section) {
    var params = new URLSearchParams(window.location.search);
    params.delete("section_id");
    var inputs = section.querySelectorAll(
      ".frg-personalize input[type=radio], .frg-explore input[type=checkbox]",
    );
    var managed = {};
    Array.prototype.forEach.call(inputs, function (inp) {
      managed[inp.name] = true;
    });
    Object.keys(managed).forEach(function (name) {
      params.delete(name);
    });
    Array.prototype.forEach.call(inputs, function (inp) {
      if (inp.checked) params.append(inp.name, inp.value);
    });
    return params;
  }

  function frgSetApplyUrl(section, query) {
    var url = window.location.pathname + (query ? "?" + query : "");
    Array.prototype.forEach.call(
      section.querySelectorAll(".frg-personalize, .frg-explore"),
      function (d) {
        d.__applyUrl = url;
      },
    );
    return url;
  }

  function frgApplyAvailability(section, getCount) {
    Array.prototype.forEach.call(
      section.querySelectorAll(".frg-personalize, .frg-explore"),
      function (drawer) {
        var mode = drawer.getAttribute("data-frg-cascade-mode") || "grayout";
        Array.prototype.forEach.call(
          drawer.querySelectorAll("[data-frg-facet-value]"),
          function (tile) {
            var group = tile.closest("[data-frg-facet-on]");
            var facetOn = !!(
              group && group.getAttribute("data-frg-facet-on") === "true"
            );
            var inp = tile.querySelector("input");
            var name = inp ? inp.name : "";
            var value = tile.getAttribute("data-frg-facet-value");
            var checked = !!(inp && inp.checked);

            var count = getCount(name, value);
            if (count == null) {
              count =
                parseInt(tile.getAttribute("data-frg-facet-count"), 10) || 0;
            }
            tile.setAttribute("data-frg-facet-count", String(count));
            var badge = tile.querySelector("[data-frg-tile-count]");
            if (badge) badge.textContent = String(count);

            var available = !facetOn || checked || count > 0;
            tile.classList.toggle("is-unavailable", !available);
            if (mode === "hide") {
              tile.classList.toggle("is-cascade-hidden", !available);
            } else {
              tile.classList.remove("is-cascade-hidden");
            }
            if (inp) inp.disabled = facetOn && !available;
          },
        );
      },
    );
  }

  function frgUpdateCounts(section, doc) {
    var c = doc.querySelector("[data-frg-count]");
    if (!c) return;
    var total = c.getAttribute("data-frg-count");
    Array.prototype.forEach.call(
      section.querySelectorAll(
        "[data-frg-result-count], [data-frg-explore-count]",
      ),
      function (el) {
        el.textContent = total;
      },
    );
  }

  function frgRecompute(section) {
    if (!section || !section.querySelector) return;
    var sectionId = frgCascadeSectionId(section);
    if (!sectionId) return;

    var params = frgCollectParams(section);
    var query = params.toString();
    frgSetApplyUrl(section, query);

    if (frgCascadeCtrls.get(section)) frgCascadeCtrls.get(section).abort();
    var ctrl = new AbortController();
    frgCascadeCtrls.set(section, ctrl);

    var url =
      window.location.pathname +
      "?" +
      (query ? query + "&" : "") +
      "section_id=" +
      sectionId;

    fetch(url, { signal: ctrl.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        frgUpdateCounts(section, doc);

        var map = {};
        Array.prototype.forEach.call(
          doc.querySelectorAll("[data-frg-facet-value]"),
          function (t) {
            var i = t.querySelector("input");
            var k =
              (i ? i.name : "") + "|" + t.getAttribute("data-frg-facet-value");
            map[k] = parseInt(t.getAttribute("data-frg-facet-count"), 10) || 0;
          },
        );
        frgApplyAvailability(section, function (name, value) {
          var k = name + "|" + value;
          return k in map ? map[k] : 0;
        });
      })
      .catch(function () {});
  }

  function frgScheduleRecompute(section) {
    if (!section) return;
    var t = frgCascadeTimers.get(section);
    if (t) clearTimeout(t);
    frgCascadeTimers.set(
      section,
      setTimeout(function () {
        frgRecompute(section);
      }, 250),
    );
  }

  function frgEscapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function frgBuildActiveFacets(section) {
    var container = section.querySelector("[data-frg-active-facets]");
    if (!container) return;

    var labels = {};
    var src = section.querySelector("[data-frg-facet-labels]");
    if (src) {
      try {
        labels = JSON.parse(src.textContent);
      } catch (e) {}
    }
    var collectionUrl =
      container.getAttribute("data-collection-url") || window.location.pathname;

    var all = [];
    var filters = [];
    new URLSearchParams(window.location.search).forEach(function (value, name) {
      all.push([name, value]);
      if (name.indexOf("filter.") === 0) filters.push([name, value]);
    });

    if (!filters.length) {
      container.innerHTML = "";
      container.hidden = true;
      return;
    }

    function labelFor(name, value) {
      if (labels[name] && labels[name][value]) return labels[name][value];
      if (name.indexOf("fragrance_exclusive") !== -1) return "Exclusive";
      return value;
    }

    function removeUrl(targetName, targetValue) {
      var keep = new URLSearchParams();
      var skipped = false;
      all.forEach(function (pair) {
        if (!skipped && pair[0] === targetName && pair[1] === targetValue) {
          skipped = true;
          return;
        }
        keep.append(pair[0], pair[1]);
      });
      var q = keep.toString();
      return window.location.pathname + (q ? "?" + q : "");
    }

    var html = "";
    filters.forEach(function (pair) {
      html +=
        '<a class="fragrance-coll__chip" href="' +
        frgEscapeHtml(removeUrl(pair[0], pair[1])) +
        '" rel="nofollow" data-no-instant>' +
        '<span class="fragrance-coll__chip-label">' +
        frgEscapeHtml(labelFor(pair[0], pair[1])) +
        "</span>" +
        '<span class="fragrance-coll__chip-x" aria-hidden="true">&times;</span>' +
        "</a>";
    });
    if (filters.length > 1) {
      html +=
        '<a class="fragrance-coll__chip fragrance-coll__chip--clear" href="' +
        frgEscapeHtml(collectionUrl) +
        '" data-no-instant>' +
        "Clear all</a>";
    }

    container.innerHTML = html;
    container.hidden = false;
  }

  function frgInitCascade(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var seen = [];
    Array.prototype.forEach.call(
      root.querySelectorAll(".frg-personalize, .frg-explore"),
      function (d) {
        var section = d.closest(".shopify-section") || document;
        if (seen.indexOf(section) !== -1) return;
        seen.push(section);

        frgSetApplyUrl(section, frgCollectParams(section).toString());
        frgApplyAvailability(section, function () {
          return null;
        });
        frgBuildActiveFacets(section);
      },
    );
  }

  function setupCollectionCascade() {
    if (window.__frgCascadeBound) return;
    window.__frgCascadeBound = true;

    document.addEventListener("change", function (e) {
      if (!e.target || !e.target.closest) return;
      var drawer = e.target.closest(".frg-personalize, .frg-explore");
      if (!drawer) return;
      if (e.target.type !== "radio" && e.target.type !== "checkbox") return;
      frgScheduleRecompute(drawer.closest(".shopify-section") || document);
    });
  }

  var frgNavCtrl = null;

  function frgNavigate(url, push) {
    if (push === undefined) push = true;

    var anchor = document.querySelector(".frg-personalize, .frg-explore");
    var sectionId = anchor && anchor.getAttribute("data-section-id");
    var wrapper = sectionId
      ? document.getElementById("shopify-section-" + sectionId)
      : null;
    if (!wrapper) {
      window.location.href = url;
      return;
    }

    Array.prototype.forEach.call(
      document.querySelectorAll(
        ".frg-personalize.is-open, .frg-explore.is-open",
      ),
      function (d) {
        d.classList.remove("is-open");
        d.setAttribute("aria-hidden", "true");
      },
    );
    document.documentElement.classList.remove(
      "frg-personalize-lock",
      "frg-explore-lock",
    );

    var results = wrapper.querySelector(".fragrance-coll__results");
    if (results) results.classList.add("is-loading");

    if (frgNavCtrl) frgNavCtrl.abort();
    frgNavCtrl = new AbortController();

    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", sectionId);

    fetch(fetchUrl.toString(), { signal: frgNavCtrl.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        wrapper.innerHTML = html;
        if (push) history.pushState({ frgNav: true }, "", url);

        initAll(wrapper);
        var top = wrapper.querySelector(".fragrance-coll__toolbar") || wrapper;
        var y = top.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({
          top: Math.max(0, y),
          behavior: prefersReducedMotion() ? "auto" : "smooth",
        });
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        window.location.href = url;
      });
  }

  function setupCollectionAjaxNav() {
    if (window.__frgAjaxNavBound) return;
    window.__frgAjaxNavBound = true;

    document.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      var link = e.target.closest("a[href]");
      if (!link) return;
      var relevant =
        link.closest("[data-frg-active-facets]") ||
        link.closest(".frg-explore__row") ||
        link.closest(".fragrance-coll__pagination") ||
        link.classList.contains("frg-personalize__clear");
      if (!relevant) return;

      var href = link.getAttribute("href");
      if (!href || href.charAt(0) === "#") return;
      var target = new URL(href, window.location.origin);

      if (target.pathname !== window.location.pathname) return;

      e.preventDefault();
      frgNavigate(target.pathname + target.search);
    });

    window.addEventListener("popstate", function () {
      frgNavigate(window.location.pathname + window.location.search, false);
    });
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      container.querySelectorAll(".frg-hero"),
      initHero,
    );
    Array.prototype.forEach.call(
      container.querySelectorAll(".ffn"),
      initFeaturedNotes,
    );
    Array.prototype.forEach.call(
      container.querySelectorAll("[data-frg-slider]"),
      initSlider,
    );
    Array.prototype.forEach.call(
      container.querySelectorAll("[data-frsb]"),
      initStickyBanner,
    );
    frgInitCascade(container);
  }

  setupCollectionPersonalize();
  setupCollectionExplore();
  setupCollectionCascade();
  setupCollectionAjaxNav();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target || document);
  });
})();
